import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useLocation } from "react-router-dom";
import DemobilizationTab from "./DemobilizationTab/DemobilizationTab";
import EreTab from "./EreTab/EreTab";
import EreAnnualVacation from "./EreAnnualVacation/EreAnnualVacation";
import AbscondingRunWayTab from "./AbscondingRunWay/AbscondingRunWayTab";
import TerminationFinalExit from "./TerminationFinalExit/TerminationFinalExit";
import ResignationTab from "./Resignation/ResignationTab";
import NakalKafalaTab from "./NakalKafala/NakalKafalaTab";
import Idle from "./Idle/Idle";
import nodeinstance from "../../../../nodeInstance";
import { checkAccessFn } from "../../../../utils/checkAccess";

export default function Demobilization() {
  const location = useLocation();
  const dispatch = useDispatch();
  const dashboardData = useSelector((state) => state.dashboardData);
  
  const token = localStorage.getItem("nodeToken");

  const title = [
    { label: "DEMOBILIZATION", link: "/dashboard/demobilization" },
  ];
  
  useEffect(() => {
    dispatch(setBreadCrumb(title));
  }, []);

  const checkAccess = (module, name) => checkAccessFn(dashboardData, module, name);

  const tabsConfig = useMemo(() => [
    { id: 0, label: "DEMOBILIZATION", permission: "active-view", param: "null", Component: DemobilizationTab },
    { id: 1, label: "IDLE", permission: "idle-view", param: "IDLE", Component: Idle },
    { id: 2, label: "ERE - EMERGENCY LEAVE", permission: "ere-view", param: "ERE-EMERGENCY LEAVE", Component: EreTab },
    { id: 3, label: "ERE - ANNUAL VACATION", permission: "ere-view", param: "ERE-ANNUAL VACATION", Component: EreAnnualVacation },
    { id: 4, label: "ABSCONDING/RUN AWAY", permission: "run-away-view", param: "ABSCONDING-RUN AWAY", Component: AbscondingRunWayTab },
    { id: 5, label: "TERMINATION - FINAL EXIT", permission: "final-exit-view", param: "TERMINATION-FINAL EXIT", Component: TerminationFinalExit },
    { id: 6, label: "RESIGNATION - FINAL EXIT", permission: "final-exit-view", param: "RESIGNATION-FINAL EXIT", Component: ResignationTab },
    { id: 7, label: "NAKAL KAFALA - FINAL EXIT", permission: "nakal-kafala-demobilization-view", param: "NAKAL KAFALA-FINAL EXIT", Component: NakalKafalaTab },
  ], []);

  const allowedTabs = useMemo(() => 
    tabsConfig.filter(tab => checkAccess("DEMOBILIZATION", tab.permission)),
    [dashboardData, tabsConfig]
  );

  //tab index
  const [index, setIndex] = useState(-1);
  const [params, setParams] = useState();

  useEffect(() => {
    if (allowedTabs.length > 0) {
      if (index === -1 || !allowedTabs.find(t => t.id === index)) {
        setIndex(allowedTabs[0].id);
        setParams(allowedTabs[0].param);
      }
    }
  }, [allowedTabs, index]);

  const handleIndex = (itemNumer, data) => {
    setIndex(itemNumer);
    setParams(data);
  };

  const [globalData, setGlobalData] = useState();
  const GetEmployeeData = async () => {
    if (!params || params === "null") return;
    const encodedParameter = encodeURIComponent(params);
    try {
      const response = await nodeinstance.get(
        `/demobilization/idleCandidates/${encodedParameter}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setGlobalData(response?.data);
      }
    } catch (error) {
      console.log("error to be seen here....", error);
      dispatch(
        setAppError({
          msg: "Failed to get the data",
        })
      );
    }
  };
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    // Don't call API for modernized tabs that use SmartDownloadPagination
    if (index === 0 || index === 4 || index === 5 || index === 6 || index === 7 || index === -1) {
      return;
    }
    // GetEmployeeData();
  }, [params, trigger, index]);

  const activeTab = tabsConfig.find(t => t.id === index);

  return (
    <>
      <div className={`ml-5 mr-5`}>
        <div className="flex flex-wrap p-4 gap-2">
          {allowedTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleIndex(tab.id, tab.param)}
              className={`p-2 px-4 h-10 uppercase text-xs rounded-md transition-colors ${
                index === tab.id ? "bg-blue text-white" : "bg-white text-black border border-gray-200 hover:bg-gray-50"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="mt-4">
          {activeTab ? (
            <activeTab.Component
              setTrigger={setTrigger}
              trigger={trigger}
              globalData={globalData}
              setIndex={handleIndex}
            />
          ) : (
            allowedTabs.length === 0 && (
              <div className="flex justify-center items-center h-40 text-gray-500">
                You do not have permission to view any Demobilization tabs.
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
}
